import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import * as layouts from "../../GramLayouts/index";

import GetPageData from "../../hooks/GetPageData";
import LoadingComponet from "../../components/Loading/LoadingComponet";
import { useParams } from "react-router-dom";
// import pagedata from "../../gramdata/developmentWork";

// import pagedata from "../../gramdata/egramsevao";

import TitleContainer from "../../Layouts/Achievements/TitleContainer";
import LayoutContainer from "../../components/LayoutsContainer";
import { useSelector } from "react-redux";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      minHeight: "60vh",
    },
  },
  titleContainer: {
    paddingTop: theme.spacing(5),
    [theme.breakpoints.down("md")]: {
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(2),
    },
  },
}));

const EgramSchemes = () => {
  const params = useParams();

  const classes = useStyles();
  const gramId = useSelector((state) => state.util.currentGramId);

  const { ready, data, error } = GetPageData(`service`);

  return ready && data ? (
    <div className={classes.root}>
      <LayoutContainer>
        {data?.title && (
          <div className={classes.titleContainer}>
            <TitleContainer title={data.title} />
          </div>
        )}
        {data.data?.map((data, index) => {
          const Layout = layouts[data?.layout];
          return <Layout key={index} data={data} />;
        })}
      </LayoutContainer>
    </div>
  ) : (
    <LoadingComponet />
  );
  // return ready && data ? (
  //   <div className={classes.root}>
  //     {data?.data?.map((data, index) => {
  //       const Layout = layouts[data?.layout];
  //       return <Layout key={index} data={data} />;
  //     })}
  //   </div>
  // ) : (
  //   <div>
  //     <LoadingComponet />
  //   </div>
  // );
};
export default EgramSchemes;
